export default __webpack_public_path__ + "static/media/video-1.f6c349fa.mp4";